import React from "react";

const ExpandUp = ({ isActive }: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.8"
        cx="8"
        cy="8"
        r="8"
        transform="rotate(-180 8 8)"
        fill="#5F67E0"
      />
      <path
        d="M12.7726 10.0304C12.632 10.171 12.4412 10.25 12.2423 10.25C12.0435 10.25 11.8527 10.171 11.7121 10.0304L7.9996 6.31791L4.2871 10.0304C4.14565 10.167 3.95619 10.2426 3.75955 10.2409C3.5629 10.2392 3.37479 10.1603 3.23573 10.0213C3.09668 9.88222 3.0178 9.69411 3.01609 9.49746C3.01438 9.30081 3.08998 9.11136 3.2266 8.96991L7.46935 4.72716C7.60999 4.58656 7.80072 4.50757 7.9996 4.50757C8.19847 4.50757 8.3892 4.58656 8.52985 4.72716L12.7726 8.96991C12.9132 9.11056 12.9922 9.30129 12.9922 9.50016C12.9922 9.69903 12.9132 9.88976 12.7726 10.0304Z"
        fill="white"
      />
    </svg>
  );
};

export default ExpandUp;
